import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=4859013a&"
import script from "./AddSale.js?vue&type=script&lang=js&"
export * from "./AddSale.js?vue&type=script&lang=js&"
import style0 from "./AddSale.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports